export const MIME_TYPES = {
  ALL: ['image/*', 'audio/mpeg', 'audio/ogg', 'audio/wav'],
  IMAGE_ALL: ['image/*'],
  AUDIO_ALL: ['audio/mpeg', 'audio/ogg', 'audio/wav']
};

export const MIME_FILTERS = {
  IMAGE: 'image/',
  AUDIO: 'audio/'
};
